import React from 'react';
import MainConfig from './MainConfig';
import AxisConfig from '../AxisConfig';
import SeriesConfig from '../SeriesConfig';
import HorizontalAxisConfig from './HorizontalAxisConfig';
import LegendControl from '../LegendControl';

export const DEFAULT_CONFIGURATION = {
  chartTitle: '',
  legendAnchor: 'bottom-right',
  pointSize: 'small',
  showLabels: true,
  horizontalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  verticalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  scale: 1,
  axisPrefix: null,
  axisSuffix: null,
  secondaryAxisPrefix: null,
  secondaryAxisSuffix: null,
  minValue: null,
  maxValue: null,
  horizontalMinValue: null,
  horizontalMaxValue: null,
  useDataColor: true,
  colors: {},
  percentile: 80, // user adjustable value to determine what percentile of nodes should have label
  percentileNodeSize: 0, // computed value to determine which nodes should show label based on node size
  backgroundColor: 'transparent',
  gridColor: 'transparent',
};

function ScatterBubblePlotConfiguration({ meta, horizontalSortType }) {
  return (
    <>
      <MainConfig />
      <LegendControl meta={meta} />
      <HorizontalAxisConfig horizontalSortType={horizontalSortType} />
      <AxisConfig axis='vertical' active />
      <SeriesConfig meta={meta} />
    </>
  );
}

export default ScatterBubblePlotConfiguration;
